import React, { Component } from 'react';
import './App.css';
import Header from './Header';
import Title from './Title';
import FrameAreaLeft from './FrameAreaLeft';
import FrameAreaRight from './FrameAreaRight';
import Tabs from './Tabs/Tabs';
import AdditionalInfo from './AdditionalInfo';
import Footer from './Footer';
import { connect } from 'react-redux';
import ScrollToTop from "react-scroll-up";
import ReactPixel from 'react-facebook-pixel';
import Constants from './Config/Config';

const printOnCanvasCatID = 45; // 44 for testing server
const URL = Constants.URL.root+'/webservices/getProductsWC.php';

class App extends Component {

    constructor(props) {
        super(props)
        this.state = {
            page: 1,
            limit: 1,
            error: null
        }
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        this.fetchPrintOnCanvasProducts(printOnCanvasCatID);
        window.addEventListener('resize', this.updateWindowDimensions);
        ReactPixel.init('750285538674235');
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    fetchPrintOnCanvasProducts = (category) => {
        var self = this;
        const page = this.state.page;
        const per_page = this.state.limit;
        fetch(URL+'?page='+page+'&per_page='+per_page+'&category='+category)
        .then(response => {
            if (!response.ok) {
                throw Error('Network request failed.')
            }
            return response;
        })
        .then(data => data.json())
        .then(data => {
            if ( self.props.selectedLayout.size === 0 )
                self.selectLayout(data[0]);
        }, (ex) => {
            console.log('error in API for layout')
            self.fetchPrintOnCanvasProducts(printOnCanvasCatID);
        })
    }

    selectLayout = (layout) => {
        this.props.dispatch({
            type: 'SET_STATE',
            state: {
                selectedLayout: layout
            }
        })
    };

    updateWindowDimensions() {
        this.props.dispatch({
            type: 'SET_STATE',
            state: {
                viewportWidth: window.innerWidth,
                viewportHeight: window.innerHeight
            }
        })
    }

    render() {
        return (
            <div className="main-content-outer">
                <div className="container-fluid">
                    <div className="row">
                        <Header {...this.props} />
                        <Title {...this.props} />
                        <div className="farme_cust full_width">
                            <div className="container">
                                <div className="row">
                                    <FrameAreaLeft {...this.props} />
                                    <FrameAreaRight {...this.props} />
                                </div>
                            </div>
                        </div>
                        <Tabs {...this.props} />
                        <AdditionalInfo />
                        <Footer />
                        <ScrollToTop showUnder={100}>
                            <button title='Back to top' className='scroll'>
                                <span className='arrow-up glyphicon glyphicon-chevron-up'></span>
                            </button>
                        </ScrollToTop>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        frameProducts: state.get('frameProducts'),
        productsCount: state.get('productsCount'),
        frameCategories: state.get('frameCategories'),
        displayCategory: state.get('displayCategory'),
        catProCount: state.get('catProCount'),
        frameLoading: state.get('frameLoading'),
        selectedFrame: state.get('selectedFrame'),
        frameImage: state.get('frameImage'),
        frameTotal: state.get('frameTotal'),
        frameSizeH: state.get('frameSizeH'),
        frameSizeW: state.get('frameSizeW'),
        frameFullDimension: state.get('frameFullDimension'),
        canvasImage: state.get('canvasImage'),
        canvasThumbImage: state.get('canvasThumbImage'),
        frameImageHeight: state.get('frameImageHeight'),
        frameImageWidth: state.get('frameImageWidth'),
        uploadedImageHeight: state.get('uploadedImageHeight'),
        uploadedImageWidth: state.get('uploadedImageWidth'),
        imageSizeError: state.get('imageSizeError'),
        aspectRatio: state.get('aspectRatio'),
        framedCalc: state.get('framedCalc'),

        actualFrameSizeH: state.get('actualFrameSizeH'),
	    actualFrameSizeW: state.get('actualFrameSizeW'),
		actualFrameFullDimension: state.get('actualFrameFullDimension'),
        canvasFrameTotal: state.get('canvasFrameTotal'),

        wallcolor: state.get('wallcolor'),

        roomImages: state.get('roomImages'),
        selectedRoomImage: state.get('selectedRoomImage'),

        layouts: state.get('layouts'),
        selectedLayout: state.get('selectedLayout'),

        wrapping: state.get('wrapping'),
        selectedWrapping: state.get('selectedWrapping'),
        wrapEdge: state.get('wrapEdge'),

        stretching: state.get('stretching'),
        selectedStretching: state.get('selectedStretching'),
        stretchingTotal: state.get('stretchingTotal'),

        hanging: state.get('hanging'),
        selectedHanging: state.get('selectedHanging'),

        libraryImageUploading: state.get('libraryImageUploading'),

        showMeHow: state.get('showMeHow'),

        qty: state.get('qty'),
        cartQty: state.get('cartQty'),
        customizeQTY: state.get('customizeQTY'),
        cart1ItemTotal: state.get('cart1ItemTotal'),
        uploadedFile: state.get('uploadedFile'),
        selectedTab: state.get('selectedTab'),

        viewportWidth: state.get('viewportWidth'),
        viewportHeight: state.get('viewportHeight'),
        rightFrameHeight: state.get('rightFrameHeight'),
    }
}

export default connect(mapStateToProps)(App);